import React, { useState, useEffect } from "react";
import "./ShiftCreation.css";
import { shiftsPost, shiftsGets, shiftDeleteById } from "../../../services/shiftsService";

const ShiftCreation = () => {
  const [shiftName, setShiftName] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [totalHours, setTotalHours] = useState(0);
  const [message, setMessage] = useState("");

  const [shiftList, setShiftList] = useState([]);

  // Fetch all shifts
  const loadShifts = async () => {
    try {
      let res = await shiftsGets();
      setShiftList(res.data);
    } catch (err) {
      console.log("Error loading shifts", err);
    }
  };

  useEffect(() => {
    loadShifts();
  }, []);

  const calculateHours = (start, end) => {
    if (!start || !end) return;
    let s = parseInt(start.split(":")[0]);
    let e = parseInt(end.split(":")[0]);
    let diff = e - s;
    if (diff < 0) diff += 24;
    setTotalHours(diff);
  };

  const handleSubmit = async () => {
    if (!shiftName || !startTime || !endTime) {
      setMessage("Please fill all fields");
      return;
    }

    const payload = {
      shiftName,
      startTime: startTime + ":00",
      endTime: endTime + ":00",
      totalHours,
      createdBy: "admin"
    };

    try {
      await shiftsPost(payload);
      setMessage("Shift Created Successfully!");

      // Reset form
      setShiftName("");
      setStartTime("");
      setEndTime("");
      setTotalHours(0);

      // Reload table
      loadShifts();
    } catch (error) {
      console.error("❌ Error:", error);
      setMessage("Failed to create shift");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this shift?")) return;

    try {
      await shiftDeleteById(id);
      loadShifts();
    } catch (err) {
      console.log("Delete error:", err);
    }
  };

  return (
    <div>
      {/* SHIFT BOX */}
      <div className="shift-box">
        <h2 className="text-center">Create Shift</h2>

        <div className={`floating-group ${shiftName ? "filled" : ""}`}>
          <input type="text" value={shiftName} 
            onChange={(e) => setShiftName(e.target.value)} required />
          <label>Shift Name</label>
        </div>

        <div className={`floating-group ${startTime ? "filled" : ""}`}>
          <input
            type="time"
            value={startTime}
            onChange={(e) => {
              setStartTime(e.target.value);
              calculateHours(e.target.value, endTime);
            }}
            required
          />
          <label>Start Time</label>
        </div>

        <div className={`floating-group ${endTime ? "filled" : ""}`}>
          <input
            type="time"
            value={endTime}
            onChange={(e) => {
              setEndTime(e.target.value);
              calculateHours(startTime, e.target.value);
            }}
            required
          />
          <label>End Time</label>
        </div>

        {/* <div className="floating-group filled">
          <input type="number" value={totalHours} readOnly />
          <label>Total Hours</label>
        </div> */}

        <button className="submit-btn" onClick={handleSubmit}>Create Shift</button>
        {message && <p className="msg">{message}</p>}
      </div>

      {/* TABLE SECTION */}
      <h2 className="text-center">Shift List</h2>

      <table className="shift-table-cre">
        <thead>
          <tr>
            <th>ID</th>
            <th>Shift Name</th>
            <th>Start Time</th>
            <th>End Time</th>
            {/* <th>Total Hours</th> */}
            {/* <th>Created By</th> */}
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {shiftList.map((shift) => (
            <tr key={shift.shiftId}>
              <td>{shift.shiftId}</td>
              <td>{shift.shiftName}</td>
              <td>{shift.startTime}</td>
              <td>{shift.endTime}</td>
              {/* <td>{shift.totalHours} hrs</td> */}
              {/* <td>{shift.createdBy}</td> */}
              <td>
                <button className="delete-btn" onClick={() => handleDelete(shift.shiftId)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ShiftCreation;
